import axios from '@/axios';

export default {
  getMonthlyCompliance(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/' + data.organizationId + '/complianceList';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            sort: data.sort,
            dir: data.dir,
            search: data.search,
            year: data.year,
            month: data.month,
            clinic: data.clinic,
            status: data.status,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSuperAdminComplianceCount(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/superAdminComplianceCount';
    return new Promise((resolve, reject) => {
      axios
        .get(path, { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getSuperAdminCompliance(_context, data) {
    let path = '/api/v1/monthlyCompliance/superAdminCompliance';
    return new Promise((resolve, reject) => {
      axios
        .get(path, { params: data })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getPreviousMonthCompliance(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/previousMonthCompliance/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            month: data.month,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  uploadFiles(_context, data) {
    let path = '/api/v1/monthlyCompliance/uploadFiles';
    return new Promise((resolve, reject) => {
      let config = {
        header: {
          'Content-Type': 'multipart/form-data',
        },
      };
      axios
        // @ts-ignore
        .post(path, data, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  downloadPdf(_context, url) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { responseType: 'blob' })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  startCompliance(_context, data) {
    let path = '/api/v1/monthlyCompliance/start/' + data;
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  udpatebookingDetails(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/updateBookingDetails/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addSuperAdminGeneralNotes(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/superAdminGeneralNotes/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addSuperAdminChangeRequest(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/superAdminChangeRequest/' + data.complianceId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePhotos(_context, data) {
    let path = '/api/v1/monthlyCompliance/updatePhotos/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  approveRejectCompliance(_context, data) {
    let path =
      '/api/v1/monthlyCompliance/approveRejectCompliance/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateVideos(_context, data) {
    let path = '/api/v1/monthlyCompliance/updateVideos/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPreviousMonthDetails(_context, data) {
    let path = '/api/v1/monthlyCompliance/previousMonthComplianceNotes/' + data.clinicId;
    return new Promise((resolve, reject) => {
      axios
        .post(path, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchDetails(_context, data) {
    let path = '/api/v1/monthlyCompliance/' + data.clinicId + '/details'; //data.clinicId is the complianceID
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchOrganisationComplianceList(_context, data) {
    let path = '/api/v1/monthlyCompliance/' + data.orgId + '/complianceList';
    return new Promise((resolve, reject) => {
      axios
        .get(path, {
          params: {
            page: data.page,
            limit: data.limit,
            sort: data.sort,
            search: data.search,
            year: data.year,
            month: data.month,
            clinic: data.clinic,
            status: data.status,
          },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchUnsetProducts(_context, data) {
    let path = '/api/v1/monthlyCompliance/' + data.clinicId + '/clinic/unset-products?month=' + data.month + '&year=' + data.year;
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchClinicDrugbookProducts(_context, data) {
    let path = '/api/v1/monthlyCompliance/' + data.clinicId + '/clinic/stocktake?complianceId=' + data.complianceId;
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  insertStockTakeProduct(_context, data) {
    let path = 'api/v1/monthlyCompliance/' + data.complianceId + '/stocktake';
    return new Promise((resolve, reject) => {
      axios
        .post(path, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateStockTakeProduct(_context, data) {
    let path = 'api/v1/monthlyCompliance/' + data.complianceId + '/stocktake/' + data.productId;
    return new Promise((resolve, reject) => {
      axios
        .put(path, data.payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchStocktakeFlagFeature(_context, data) {

    let path = `api/v1/monthlyCompliance/${data.orgId}/${data.clinicId}/stocktake/status`;
    return new Promise((resolve, reject) => {
      axios
        .get(path)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
